import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"card-header\"><span class=\"text-header\"><i class=\"fa-solid fa-wifi\"></i> Recomendações </span></div><div class=\"card-body\"><p class=\"text-paragraph\"> Para evitar que a conexão da vídeo chamada tenha uma qualidade indesejada, recomendamos que a sessão seja realizada utilizando o Wi-Fi. </p></div>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
}